(function () {
    "use strict";

    var data = window.themeData || {};

    function dragHandler() {
        var dropContainer = document.querySelector(".form__file");
        var fileInput = document.getElementById("file");
        if (!dropContainer || !fileInput) {
            return;
        }

        var fileListEl = document.querySelector(".form__file__content span");
        var maxFiles = data.maxFiles || 5;

        function renderFileList(files) {
            if (!fileListEl) {
                return;
            }
            fileListEl.innerHTML = "";
            for (var i = 0; i < files.length; i++) {
                fileListEl.innerHTML += files[i].name + "<br>";
            }
        }

        function applyFiles(files) {
            if (files.length > maxFiles) {
                window.alert((data.i18n && data.i18n.tooManyFiles) || "Too many files selected.");
                return;
            }
            renderFileList(files);
        }

        dropContainer.addEventListener("dragover", function (e) {
            e.preventDefault();
        });

        dropContainer.addEventListener("dragenter", function () {
            dropContainer.classList.add("drag-active");
        });

        dropContainer.addEventListener("dragleave", function () {
            dropContainer.classList.remove("drag-active");
        });

        dropContainer.addEventListener("drop", function (e) {
            e.preventDefault();
            dropContainer.classList.remove("drag-active");
            if (e.dataTransfer.files.length > maxFiles) {
                window.alert((data.i18n && data.i18n.tooManyFiles) || "Too many files selected.");
                return;
            }
            fileInput.files = e.dataTransfer.files;
            renderFileList(fileInput.files);
        });

        fileInput.addEventListener("change", function () {
            applyFiles(fileInput.files);
        });
    }

    function headerMenuToggle() {
        var header = document.querySelector(".app__header");
        var toggle = header && header.querySelector(".app__header__toggle");
        var menu = header && header.querySelector(".app__header__menu");
        if (!header || !toggle || !menu) {
            return;
        }

        function closeMenu() {
            header.classList.remove("is-open");
            toggle.setAttribute("aria-expanded", "false");
        }

        function openMenu() {
            header.classList.add("is-open");
            toggle.setAttribute("aria-expanded", "true");
        }

        toggle.addEventListener("click", function () {
            if (header.classList.contains("is-open")) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        menu.addEventListener("click", function (e) {
            if (e.target.tagName === "A") {
                closeMenu();
            }
        });

        document.addEventListener("click", function (e) {
            if (header.classList.contains("is-open") && !header.contains(e.target)) {
                closeMenu();
            }
        });

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                closeMenu();
            }
        });
    }

    function carousel() {
        var section = document.querySelector(".section__stories--carousel");
        if (!section) {
            return;
        }

        var track = section.querySelector(".projects__track");
        var prevBtn = section.querySelector(".projects__arrow--prev");
        var nextBtn = section.querySelector(".projects__arrow--next");
        var progressBar = section.querySelector(".projects__progress-bar");
        if (!track) {
            return;
        }

        function cardStep() {
            var card = track.querySelector(".story");
            if (!card) {
                return track.clientWidth;
            }
            var style = window.getComputedStyle(track);
            var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
            return card.getBoundingClientRect().width + gap;
        }

        function maxScroll() {
            return Math.max(0, track.scrollWidth - track.clientWidth);
        }

        // iOS/Android rubber-band overscroll can push scrollLeft slightly
        // below 0 or above maxScroll() during a fast swipe, which without
        // clamping made the bar overshoot past 0%/100% and glitch.
        function clampedScrollLeft(max) {
            return Math.min(max, Math.max(0, track.scrollLeft));
        }

        function currentIndex(max) {
            var step = cardStep();
            return step > 0 ? Math.round(clampedScrollLeft(max) / step) : 0;
        }

        function lastIndex(max) {
            var step = cardStep();
            return step > 0 ? Math.round(max / step) : 0;
        }

        function update() {
            var max = maxScroll();
            var last = lastIndex(max);
            var index = currentIndex(max);

            if (progressBar) {
                var barWidthPercent = Math.max(15, (track.clientWidth / track.scrollWidth) * 100);
                // translateX(%) resolves against the bar's own (already
                // shrunk) width, not its wrapper, so a percent-based travel
                // distance always undershoots the wrapper's right edge.
                // Compute the travel distance in px against the wrapper
                // instead, and drive it off the live scroll ratio so the
                // bar tracks the actual scroll position, not the rounded
                // step index.
                var wrapWidth = progressBar.parentElement.clientWidth;
                var travelPx = wrapWidth * (1 - barWidthPercent / 100);
                var ratio = max > 0 ? clampedScrollLeft(max) / max : 0;
                progressBar.style.width = barWidthPercent + "%";
                progressBar.style.transform = "translateX(" + (ratio * travelPx) + "px)";
            }

            if (prevBtn) {
                prevBtn.disabled = index <= 0;
            }
            if (nextBtn) {
                nextBtn.disabled = max <= 0 || index >= last;
            }
        }

        if (prevBtn) {
            prevBtn.addEventListener("click", function () {
                var max = maxScroll();
                var index = currentIndex(max);
                var target = index - 1 <= 0 ? 0 : track.scrollLeft - cardStep();
                track.scrollTo({ left: target, behavior: "smooth" });
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener("click", function () {
                var max = maxScroll();
                var last = lastIndex(max);
                var index = currentIndex(max);
                // Snap straight to max scroll on the final step so the last
                // card's right edge lands flush on the grid instead of
                // stopping short/over by a fractional cardStep().
                var target = index + 1 >= last ? max : track.scrollLeft + cardStep();
                track.scrollTo({ left: target, behavior: "smooth" });
            });
        }

        track.addEventListener("scroll", update);
        window.addEventListener("resize", update);

        // Covers layout shifts window "resize" never fires for on mobile:
        // late-loading images and the address bar show/hide during scroll.
        if (window.ResizeObserver) {
            new ResizeObserver(update).observe(track);
        }

        update();
    }

    function formHandler() {
        var form = document.getElementById("shared-project-form");
        if (!form) {
            return;
        }

        var wrapper = document.querySelector(".section__form");
        var successMsg = document.querySelector(".successMessage");
        var resetBtn = document.querySelector(".successMessage__reset");
        var errorEl = form.querySelector(".form__error");
        var submitBtn = form.querySelector("button[type=\"submit\"]");
        var fileListEl = document.querySelector(".form__file__content span");

        function showError(message) {
            if (!errorEl) {
                return;
            }
            errorEl.textContent = message;
            errorEl.hidden = !message;
        }

        form.addEventListener("submit", function (e) {
            e.preventDefault();

            if (!form.reportValidity()) {
                return;
            }

            showError("");
            submitBtn.disabled = true;

            var formData = new FormData(form);
            if (data.nonce) {
                formData.set("nonce", data.nonce);
            }

            fetch(data.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: formData
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    if (result.success) {
                        if (wrapper) {
                            wrapper.classList.add("success");
                        }
                        if (successMsg) {
                            successMsg.hidden = false;
                            var title = successMsg.querySelector(".successMessage__title");
                            var content = successMsg.querySelector(".successMessage__content");
                            if (title && result.data && result.data.heading) {
                                title.textContent = result.data.heading;
                            }
                            if (content && result.data && result.data.content) {
                                content.textContent = result.data.content;
                            }
                        }
                        form.reset();
                        if (fileListEl) {
                            fileListEl.innerHTML = "";
                        }
                    } else {
                        var message = (result.data && result.data.message) || (data.i18n && data.i18n.genericError);
                        showError(message);
                    }
                })
                .catch(function () {
                    showError((data.i18n && data.i18n.genericError) || "Something went wrong. Please try again.");
                })
                .finally(function () {
                    submitBtn.disabled = false;
                });
        });

        if (resetBtn) {
            resetBtn.addEventListener("click", function () {
                if (wrapper) {
                    wrapper.classList.remove("success");
                }
                if (successMsg) {
                    successMsg.hidden = true;
                }
            });
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        headerMenuToggle();
        dragHandler();
        carousel();
        formHandler();
    });
})();
